import { msg } from "@lingui/core/macro"
import { useLingui } from "@lingui/react"
import { createFileRoute } from "@tanstack/react-router"
import { useState } from "react"
import { extractErrorMessage } from "../lib/api/errors"
import { authClient } from "../lib/auth-client"
import { useProduct, useTenant } from "../lib/tenant"
import { ResetPasswordView } from "./-reset-password/ResetPasswordView"

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
})

function ResetPasswordPage(): React.JSX.Element {
  const branding = useTenant().branding
  const product = useProduct()
  const { i18n } = useLingui()
  const token = new URLSearchParams(window.location.search).get("token") ?? ""
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | undefined>(undefined)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (password: string): Promise<void> => {
    setError(undefined)
    setLoading(true)
    try {
      const { error: resetError } = await authClient.resetPassword({ newPassword: password, token })
      if (resetError) {
        setError(resetError.message || i18n._(msg`Couldn't reset your password. The link may have expired.`))
        return
      }
      setSuccess(true)
    } catch (err) {
      setError(extractErrorMessage(err))
    } finally {
      setLoading(false)
    }
  }

  return (
    <ResetPasswordView
      logo={branding?.logo}
      appName={branding?.name}
      product={product}
      loginBackground={branding?.loginBackground}
      loading={loading}
      error={error}
      success={success}
      tokenMissing={!token}
      onSubmit={handleSubmit}
    />
  )
}
